// const apiUrl = "http://192.168.0.111:7999/api/v1";
const apiUrl = "https://xpresswheels.tchub.in/api/v1";
export default apiUrl;
// const apiUrl = "http://192.168.0.111:7999/api/v1"
// const apiUrl="https://xpresswheels.tchub.in/api/v1"
// export default apiUrl;
